import ReactLoading from 'react-loading'

export default function LoadingScreen({mensaje = 'Cargando información, espere un momento', styles = '', spinnerStyles = '', onCancel}) {
    return(
        <div className={`bg-gray-200/75 w-full h-screen fixed z-[99999] top-0 right-0 bottom-0 left-0 ${styles}`}>
            <ReactLoading type="spin" color="#1A3D82" height='120px' width='120px' className={`mt-72 mr-auto ml-auto ${spinnerStyles}`}/>
            <p className='text-center mt-6'>{mensaje}</p>
            {onCancel && <button onClick={onCancel} className='block mx-auto mt-4 px-6 py-2 bg-nimbus text-white rounded-lg hover:opacity-80 transition-opacity'>Cancelar</button>}
        </div>
    )
    }